import type { EditDetailedSummaryDepreciationRequestProps } from '@services/api/depreciation/types'
import type { EditDetailedSummaryDepreciationFormProps } from '../components/modals/EditDetailedSummaryDepreciation/form/types'

export const parseEditDetailedSummaryDepreciationPayload = (formData: EditDetailedSummaryDepreciationFormProps) => {
  const payload: EditDetailedSummaryDepreciationRequestProps = {
    routeParams: {
      filiCode: formData.filiCode!
    },
    bodyParams: {
      referenceDate: formData.competenceDate!,
      accountingCode: formData.accountCode,
      accountingDescription: formData.accountDescriptionText,
      amount: formData.depreciationValue ? Number(formData.depreciationValue) : 0,
      observations: formData.observations || ''
    }
  }

  return payload
}
